import { useParams } from "react-router-dom";
import ServiceDetail from "@/components/ServiceDetail";
import NotFound from "@/pages/NotFound";
import { INDUSTRIAL_SERVICES_DATA } from "@/data/industrial-services";

export default function IndustrialServiceDetail() {
    const { service } = useParams();
    const data = INDUSTRIAL_SERVICES_DATA[service];
    if (!data) return <NotFound />;
    return <ServiceDetail data={data} track="industrial" />;
}
